module.exports = __webpack_public_path__ + "3a4cb05a359a4398045f1fa2c55fbb26.jpg";